export const EMAIL_SENDS = 'EMAIL_SENDS';